<template>
  <div class="header" style="border-bottom:1px solid #dcdfe6;box-sizing: border-box;">
    <div style="display:flex;justify:space-between;background:#ffffff;height: 10px;"></div>
    <div style="display:flex;justify:space-between;background:#ffffff">
      <img src="../assets/logomks.png" style="margin-bottom:10px;width:150px;height:50px" />
      <span style="margin-top:10px;margin-left:40px;font-size: 24px;display:inline-block;font-weight:bold">{{
        $t('Main.Battery_Matrix') }}</span>
      <LanguageSelect @language-change="handldLanguageChange"
        style="margin-left:auto;margin-right:100px;margin-bottom: 10px" />
      <Slide class="hamburger" right width:300px>
        <a id="home" href="#">
          <span class="hover" style="font-size: 12px;color:black;" @click="goto('/diagnosis-management')">{{ $t('Main.diagnosis_management')
          }}</span>
        </a>
        <a id="home" href="#">
          <span class="notallowed" style="font-size: 12px;color:#ccc;" @click="printError">{{ $t('Main.Data_Management')
          }}</span>
        </a>
        <a id="home" href="#">
          <span class="notallowed" style="font-size: 12px;color:#ccc;" @click="printError">{{ $t('Main.Battery_Balance')
          }}</span>
        </a>
        <a id="home" href="#">
          <span class="notallowed" style="font-size: 12px;color:#ccc;" @click="printError">{{ $t('Main.Contact_Us')
          }}</span>
        </a>
        <a id="home" href="#">
          <span class="notallowed" style="font-size: 12px;color:#ccc;" @click="printError">{{ $t('Main.Help') }}</span>
        </a>
        <a id="home" href="#">
          <span class="notallowed" style="font-size: 12px;color:#ccc;" @click="printError">{{ $t('Main.User_Agreement')
          }}</span>
        </a>
        <!-- <a id="home" href="#">
          <span class="hover" style="font-size: 12px;color:#ccc;" @click="goto('/project-management')">Project Management</span>
        </a>
        <a id="home" href="#">
          <span class="hover" style="font-size: 12px;color:#ccc;" @click="goto('/battery-balance')">Battery Balance</span>
        </a>
        <a id="home" href="#">
          <span class="hover" style="font-size: 12px;color:#ccc;" @click="goto('/login')">Contact Us</span>
        </a>
        <a id="home" href="#">
          <span class="hover" style="font-size: 12px;color:#ccc;" @click="goto('/user-guide')">Help</span>
        </a>
        <a  id="home" href="#">
          <span class="hover" style="font-size: 12px;color:#ccc;" @click="goto('/user-agreement')">User Agreement</span>
        </a> -->
      </Slide>
    </div>
  </div>
</template>

<script>
import { Slide } from 'vue-burger-menu'
import LanguageSelect from './LanguageSelect.vue'
export default {
  name: 'HeaderPage',
  components: {
    Slide,
    LanguageSelect
  },
  methods: {
    printError() {
      this.$message.error('此功能尚未开放，请耐心等待')
    },
    goto(url) {
      this.$router.push({
        path: url
      });
    },
    handldLanguageChange(value) {
      this.$emit('language-change', value)
    }
  }
}
</script>

<style lang="less" scoped>
.hover:hover {
  text-decoration: underline;
}

.notallowed:hover {
  cursor: not-allowed
}

.bm-overlay {
  background: #fff !important;
}

.bm-menu {
  height: 50%;
  /* 100% Full-height */
  width: 0;
  /* 0 width - change this with JavaScript */
  position: fixed;
  /* Stay in place */
  z-index: 1000;
  /* Stay on top */
  top: 0;
  left: 0;
  box-shadow: -1px 0px 10px 0px rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
  /* Black*/
  overflow-x: hidden;
  /* Disable horizontal scroll */
  padding-top: 60px;
  transition: 0.5s;
}

input#file-upload-button {
  display: none;
}


/deep/ .bm-burger-button {
  height: 15px;
  width: 20px;
}

/deep/ .line-style {
  position: absolute;
  height: 20%;
  width: 15px;
  left: 0;
  right: 0;
}


.hamburger {
  .cross-style {
    position: absolute;
    top: 12px;
    right: 2px;
    cursor: pointer;
  }

  .bm-cross {
    background: #bdc3c7;
  }

  .bm-cross-button {
    height: 24px;
    width: 24px;
  }

  .bm-menu {
    height: 50%;
    /* 100% Full-height */
    width: 0;
    /* 0 width - change this with JavaScript */
    position: fixed;
    /* Stay in place */
    z-index: 1000;
    /* Stay on top */
    top: 0;
    left: 0;
    box-shadow: -1px 0px 10px 0px rgba(0, 0, 0, 0.5);
    background-color: #ffffff;
    /* Black*/
    overflow-x: hidden;
    /* Disable horizontal scroll */
    padding-top: 60px;
    transition: 0.5s;
  }

  // .bm-menu {
  //   height: 100%; /* 100% Full-height */
  //   width: 0; /* 0 width - change this with JavaScript */
  //   position: fixed; /* Stay in place */
  //   z-index: 1000; /* Stay on top */
  //   top: 0;
  //   left: 0;
  //   background-color: rgb(63, 63, 65); /* Black*/
  //   overflow-x: hidden; /* Disable horizontal scroll */
  //   padding-top: 60px; /* Place content 60px from the top */
  //   transition: 0.5s; /*0.5 second transition effect to slide in the sidenav*/
  // }

  .bm-overlay {
    background: #fff;
  }

  .bm-item-list {
    color: #b8b7ad;
    margin-left: 10%;
    font-size: 20px;
  }

  .bm-item-list>* {
    display: flex;
    text-decoration: none;
    padding: 0.7em;
  }

  .bm-item-list>*>span {
    margin-left: 10px;
    font-weight: 700;
    color: white;
  }
}

.category-box {
  display: flex;
  font-size: 14px;

  .category-label {
    min-width: 50px;
    color: #999;
    padding-top: 3px;
    padding-right: 15px;
  }

  .category-list {
    display: flex;
    flex-flow: row wrap;
    align-items: center;

    .category-item {
      margin: 0 10px 5px 0;
      padding: 4px 10px;
      color: #666;
      border-radius: 12px;
      outline: none;
      cursor: pointer;

      &-active {
        color: #ff7752;
        font-weight: 500;
        background-color: #ddebf8;
      }
    }
  }
}

.flex-1 {
  flex: 1;
}

.category-two-menu-box.el-tooltip__popper.is-light {
  box-shadow: 0 2px 12px 0 #e1e3e6;
  border: 1px solid #f0f0f0;
}

.category-two-menu-box.el-tooltip__popper {
  padding: 0;
}

.category-two-menu-box .el-cascader-node:hover {
  color: #ff7752;
}

.category-two-menu-box .el-cascader-node.is-active {
  color: #ff7752;
}

.category-two-menu-box.el-tooltip__popper.is-light .el-cascader-panel.is-bordered {
  border-radius: 0;
  border: 0 none;
}

.category-two-menu-box.el-tooltip__popper.is-light .popper__arrow {
  border-bottom-color: #f0f0f0 !important;
}</style>